import React, {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLocationData } from '../../../store/actions/location';
import CanvasWithZoomFullscreen from './CanvasWithZoomFullscreen';
import { use } from 'react';

const FloorImageComponent = ({ floorid, enableCreateButton=false, zone_id }) => {
    const location_data = useSelector(state => state.location.location_data);
    const floor = location_data?.floors?.[floorid];
    const layerRef = React.useRef(null);
    let zones = floor?.zones ? Object.values(floor.zones) : [];
    // if(((location_data?.action_type=='edit' && location_data?.addNewZoneButtonClicked) || (location_data?.action_type=='add' && location_data?.current_modal=='AddZone')) ){
    //     const newlyAddedZoneId = location_data?.newZones?.[floorid]?.newlyAddedZone ? location_data?.newZones?.[floorid]?.zone_id_selected : null;
    //     zones = newlyAddedZoneId!== null ? [zones[newlyAddedZoneId]] : null;

    // }
    const [isCreatingPolygon, setIsCreatingPolygon] = React.useState(false);
    const [newPolygonPoints, setNewPolygonPoints] = React.useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if(location_data?.newZones?.[floorid]?.newlyAddedZone === true){
            setIsCreatingPolygon(true);
        } else {
            setIsCreatingPolygon(false);
        }
    }, [floorid]);

    const current_modal = useSelector(state => state.location?.current_modal);
    const handleZoneDelete = (floorid, zone_id) => {
        const {[zone_id]: _, ...remainingZones} = location_data.floors[floorid]?.zones || {};
        let remainingZonesTemp = {};
        if(location_data?.newZones?.[floorid]?.newlyAddedZone === true){
            const {[floorid]: __, ...remainingNewZones} = location_data.newZones;
            remainingZonesTemp = remainingNewZones;
        }
        setIsCreatingPolygon(false);
        dispatch(setLocationData({
            ...location_data,
            newZoneCoordinates: [],
            floors: {
                ...location_data.floors, [floorid]: {
                    ...location_data.floors[floorid],
                    zones: remainingZones,
                }
            },
            newZones: {
                ...remainingZonesTemp
            },
            zoneDeletedInEditMode: {
                ...location_data?.zoneDeletedInEditMode,
                [floorid]: true,
            }
        }));
        setNewPolygonPoints([]);
    }

    useEffect(() => {
        setNewPolygonPoints([]);
    }, [floorid]);

    const handleStageClick = (e) => {
        const tempZone = location_data?.newZones?.[floorid]?.zone_id_selected;
        if (!isCreatingPolygon || (location_data?.newZones?.[floorid]?.newlyAddedZone === true && location_data?.floors?.[floorid]?.zones?.[tempZone]?.zone_coordinates?.length >= 3)) return;
        const stage = e.target.getStage();
        const pointer = stage.getPointerPosition();
        const scaleX = stage.scaleX();
        const scaleY = stage.scaleY();
        const realX = (pointer.x - stage.x()) / scaleX;
        const realY = (pointer.y - stage.y()) / scaleY;
        const existing_zone_coords = location_data.floors[floorid]?.zones?.[zone_id]?.zone_coordinates || [];

        setNewPolygonPoints([...newPolygonPoints, realX, realY]);
        dispatch(setLocationData({ 
            ...location_data, floors: {
            ...location_data.floors,
            [floorid]: { ...location_data.floors[floorid],
            zones: { 
                ...location_data.floors[floorid]?.zones,
                [zone_id]: {
                    id: zone_id,
                    ...location_data.floors[floorid]?.zones?.[zone_id],
                    zone_coordinates: [...existing_zone_coords, {x : realX, y : realY}] 
                } } }
        }}) );
    };

    return (
        <div>
            {
                (()=>{
                    const props = {current_modal, location_data, floorid, floor, zones, isCreatingPolygon, enableCreateButton, newPolygonPoints, setIsCreatingPolygon, setNewPolygonPoints, handleZoneDelete, zone_id, layerRef, handleStageClick};

                  return <CanvasWithZoomFullscreen {...props} />
            })()
            }
            <p className='font12Location' style={{
                marginTop: '4px',
                marginBottom: '8px',
                color: '#6F7171',
            }}>
                {
                    current_modal == 'AddZone'? 
                    location_data?.action_type == 'edit' && !location_data?.addNewZoneButtonClicked && !location_data?.editNewFloorUpdated
                    ? 'Select a zone to edit'
                    : 'Click to add points and draw a polygon for area.'
                    : ''
                }
                
            </p>
        </div>
    );
};

export default FloorImageComponent;

